<template>
  <b-container>
    <!-- <h1 class="text-center pt-4 pb-4">Ajout d'un statut</h1>-->
    <b-form @submit="onSubmit">
      <p v-html="$t('info.removeConfirmedUser', [formatName()])"></p>

      <b-button
        class="mt-4 text-center"
        type="submit"
        variant="danger"
        :disabled="disabled"
        >{{ $t("action.confirmed") }}</b-button
      >

      <div v-if="spinner" class="text-center">
        <b-spinner
          style="width: 3rem; height: 3rem"
          variant="success"
          label="Spinning"
          disabled="labelStatus"
        ></b-spinner>
      </div>

      <div v-if="error" class="pt-4">
        <b-alert show variant="danger">
          <p>{{ error }}</p>
        </b-alert>
      </div>
    </b-form>
  </b-container>
</template>

<script>
import axios from "axios";

import { globalF } from "../../Helpers";

export default {
  mixins: [globalF],
  props: ["values", "modalid"],
  data: () => ({
    disabled: false,
    error: "",
    spinner: false,
  }),
  computed: {
    url: function () {
      let urls = this.$store.getters.getUrlsList;
      return urls[process.env.VUE_APP_WHERE].json;
    },
  },
  methods: {
    formatName() {
      return this.values.fname.concat(" ", this.values.lname);
    },
    onSubmit(evt) {
      evt.preventDefault();

      this.error = "";
      this.disabled = true;
      this.spinner = true;

      let promise = this.validateToken();
      promise.then(() => {
        this.removedUser();
      });
    },
    removedUser: function () {
      axios
        .post(
          this.url,
          { request: "removeUser", form: this.values.email },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          this.$emit("changePage", "UserList");
          this.spinner = false;
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t("info.errorgeneric");
        });
    },
  },
};
</script>
